import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AdminAreaData } from "@/types/adminArea";
import { AnalysisConfigAdminAreaData } from "@/types/project";
import { AdminAreaSettings } from "@/types/spatial";

export interface GlobalFilterState {
  // main selections
  selectedAreaIds: string[];
  // temporary selections
  selectedAreaIdsTemp: string[];
  adminAreaSettings: AdminAreaSettings | null;
  adminAreaSettingsData: AdminAreaData | null;
  adminAreaSettingsDataTemp: AdminAreaData | null;
}

export const globalFilterInitialState: GlobalFilterState = {
  selectedAreaIds: [],
  selectedAreaIdsTemp: [],
  adminAreaSettings: null,
  adminAreaSettingsData: null,
  adminAreaSettingsDataTemp: null
};

export const globalFilter = createSlice({
  name: "globalFilter",
  initialState: globalFilterInitialState,
  reducers: {
    resetGlobalFilter: () => globalFilterInitialState,
    setSelectedAreaIds: (state, action: PayloadAction<string[]>) => {
      state.selectedAreaIds = action.payload;
    },
    setSelectedAreaIdsTemp: (state, action: PayloadAction<string[]>) => {
      state.selectedAreaIdsTemp = action.payload;
    },
    applyAdminTreeGlobalFilter: (state) => {
      state.selectedAreaIds = [...state.selectedAreaIdsTemp];
      state.adminAreaSettingsData = state.adminAreaSettingsDataTemp;
    },
    applyAdminTreeGlobalFilterTemp: (state) => {
      state.selectedAreaIdsTemp = [...state.selectedAreaIds];
      state.adminAreaSettingsDataTemp = state.adminAreaSettingsData;
    },
    setAdminAreaSettings: (
      state,
      action: PayloadAction<AdminAreaSettings | null>
    ) => {
      state.adminAreaSettings = {
        ...state.adminAreaSettings,
        ...action.payload
      };
    },
    setAdminAreaSettingsData: (
      state,
      action: PayloadAction<AdminAreaData | null>
    ) => {
      state.adminAreaSettingsData = action.payload;
    },
    setAdminAreaSettingsDataTemp: (
      state,
      action: PayloadAction<AdminAreaData | null>
    ) => {
      state.adminAreaSettingsDataTemp = action.payload;
    },
    setGlobalAdminArea: (
      state,
      action: PayloadAction<AnalysisConfigAdminAreaData | null | undefined>
    ) => {
      state.adminAreaSettings = action.payload?.selectValue || null;
      state.adminAreaSettingsData = action.payload?.geoData || null;
    },
    setGlobalFilterState: (
      _state,
      action: PayloadAction<GlobalFilterState>
    ) => {
      return action.payload;
    }
  }
});

export const {
  resetGlobalFilter,
  setSelectedAreaIds,
  setSelectedAreaIdsTemp,
  applyAdminTreeGlobalFilter,
  applyAdminTreeGlobalFilterTemp,
  setAdminAreaSettings,
  setAdminAreaSettingsData,
  setAdminAreaSettingsDataTemp,
  setGlobalAdminArea,
  setGlobalFilterState
} = globalFilter.actions;

export const globalFilterReducer = globalFilter.reducer;
